/**
 * PublicFooter — kompaktowa stopka dla stron publicznych.
 * Dane administratora + kontakt + pełna lista dokumentów prawnych + copyright.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const ADMIN_FALLBACK = {
  name:    'MR JERRY JERZY FLOREK',
  nip:     '734-350-41-81',
  address: 'ul. Kościuszki 18, Nowy Sącz',
  email:   'biuro@mrjerry.pl',
  phone:   '+48 570 790 870',
};

const LINK_STYLE = {
  color: '#cbd5e1',
  textDecoration: 'none',
  fontSize: 12,
  fontWeight: 500,
  transition: 'color 0.15s ease',
};

const linkHover = (e) => { e.currentTarget.style.color = '#d4af37'; };
const linkLeave = (e) => { e.currentTarget.style.color = '#cbd5e1'; };

const PublicFooter = ({ admin = ADMIN_FALLBACK }) => {
  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent('mrjerry:cookie-open'));
  };
  return (
    <footer
      data-testid="public-footer"
      style={{
        width: '100%',
        marginTop: 32,
        padding: '18px 20px 16px',
        background: 'rgba(6, 11, 22, 0.75)',
        borderTop: '1px solid rgba(212, 175, 55, 0.15)',
        color: '#94a3b8',
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
      }}
    >
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'flex', flexWrap: 'wrap', gap: '10px 24px',
        alignItems: 'baseline', justifyContent: 'space-between',
      }}>
        {/* LEWO — Administrator + kontakt (inline) */}
        <div style={{
          display: 'flex', flexWrap: 'wrap', alignItems: 'center',
          gap: '4px 14px', fontSize: 11, lineHeight: 1.5,
        }}>
          <span style={{ color: '#f8fafc', fontWeight: 700, letterSpacing: 0.2 }}>
            {admin.name}
          </span>
          <span style={{ opacity: 0.6 }}>·</span>
          <span>{admin.address}</span>
          <span style={{ opacity: 0.6 }}>·</span>
          <span>NIP {admin.nip}</span>
          <span style={{ opacity: 0.6 }}>·</span>
          <a href={`mailto:${admin.email}`}
             style={{ color: '#cbd5e1', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}
             onMouseEnter={linkHover} onMouseLeave={linkLeave}>
            <Mail size={11} style={{ color: '#d4af37' }} /> {admin.email}
          </a>
          <span style={{ opacity: 0.6 }}>·</span>
          <a href={`tel:${admin.phone.replace(/\s/g, '')}`}
             style={{ color: '#cbd5e1', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}
             onMouseEnter={linkHover} onMouseLeave={linkLeave}>
            <Phone size={11} style={{ color: '#d4af37' }} /> {admin.phone}
          </a>
        </div>

        {/* PRAWO — Linki prawne (inline separated by dots) */}
        <nav style={{
          display: 'flex', flexWrap: 'wrap',
          gap: '4px 12px', alignItems: 'center',
        }}>
          <Link to="/regulamin" style={LINK_STYLE} onMouseEnter={linkHover} onMouseLeave={linkLeave}>Regulamin</Link>
          <span style={{ opacity: 0.4, fontSize: 11 }}>·</span>
          <Link to="/regulamin-reklamacji" style={LINK_STYLE} onMouseEnter={linkHover} onMouseLeave={linkLeave}>Regulamin reklamacji</Link>
          <span style={{ opacity: 0.4, fontSize: 11 }}>·</span>
          <Link to="/regulamin-konkursu" style={LINK_STYLE} onMouseEnter={linkHover} onMouseLeave={linkLeave}>Regulamin konkursu</Link>
          <span style={{ opacity: 0.4, fontSize: 11 }}>·</span>
          <Link to="/polityka-prywatnosci" style={LINK_STYLE} onMouseEnter={linkHover} onMouseLeave={linkLeave}>Polityka prywatności</Link>
          <span style={{ opacity: 0.4, fontSize: 11 }}>·</span>
          <Link to="/polityka-cookies" style={LINK_STYLE} onMouseEnter={linkHover} onMouseLeave={linkLeave}>Polityka cookies</Link>
          <span style={{ opacity: 0.4, fontSize: 11 }}>·</span>
          <button
            data-testid="footer-cookie-settings"
            onClick={openCookieSettings}
            style={{
              ...LINK_STYLE,
              background: 'none', border: 'none', padding: 0, cursor: 'pointer',
              font: 'inherit',
            }}
            onMouseEnter={linkHover} onMouseLeave={linkLeave}
          >
            Ustawienia cookies
          </button>
        </nav>
      </div>

      <div style={{
        maxWidth: 1100, margin: '12px auto 0',
        paddingTop: 10, borderTop: '1px dashed rgba(255, 255, 255, 0.06)',
        fontSize: 10, color: '#64748b', textAlign: 'center', letterSpacing: 0.2,
      }}>
        © {new Date().getFullYear()} {admin.name} · Wszelkie prawa zastrzeżone
      </div>
    </footer>
  );
};

export default PublicFooter;
